export const vi = {
    GENDER: {
        MAN: 'NAM',
        WOMAN: 'NỮ',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    SOURCE: {
        HUMAN: 'NHÂN LOẠI',
        MANNEQUIN: 'MA NƠ CANH',
        STYLEBOOK: 'SÁCH PHONG CÁCH',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    FASHION_STYLE: {
        basic: 'Đơn giản',
        elegance: 'Thanh lịch',
        office: 'Công sở',
        minimalist: 'Tối giản',
        vacation: 'Nghỉ dưỡng',
        street: 'Đường phố',
        sporty: 'Thể thao',
        girly: 'Nữ tính',
        sexy: 'Gợi cảm',
        gentleman: 'Quý ông',
        punk: 'Punk',
        techwear: 'Techwear',
        retro: 'Cổ điển',
        bohemian: 'Bohemian',
        unknown: 'KHÔNG XÁC ĐỊNH'
    },
    MAIN_CATEGORY: {
        OUTER: 'Áo khoác',
        TOP: 'Áo',
        PANTS: 'Quần',
        SKIRT: 'Váy',
        DRESSES: 'Đầm',
        SWIMWEAR: 'Đồ bơi',
        UNDERWEAR: 'Đồ lót',
        SHOES: 'Giày',
        BAG: 'Túi',
        CAP_HAT: 'Mũ/Nón',
        FASHION_ACC: 'Phụ kiện',
        EYEWEAR: 'Mắt kính',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    SUB_CATEGORY: {
        JACKET: 'áo khoác ngắn',
        COAT: 'áo khoác ngoài',
        JUMPER: 'áo khoác bomber',
        PADDING_COAT: 'áo khoác phao',
        VEST: 'áo gile (mặc phía trong)',
        CARDIGAN: 'áo len đan cài trước',
        HOOD_ZIPUP: 'áo khoác dây kéo có nón',
        CASUAL_TOP: 'áo thun',
        SLEEVELESS: '(áo) không tay',
        SWEATSHIRT: 'áo nỉ dài tay (tròng đầu)',
        HOODED_TSHIRT: 'áo có nón',
        SHIRTS_BLOUSE: 'áo sơ mi / áo kiểu nữ',
        KNIT_SWEATER: 'áo len đan',
        SHORTS: 'quần ngắn',
        SLACKS_COTTON_PANTS_CHINO: 'quần tây / quần kaki',
        WIDE_PANTS: 'quần ống rộng',
        JEANS: 'quần jeans',
        CARGO_PANTS: 'quần túi hộp',
        LEGGINGS: 'quần leggings',
        JOGGER_PANTS: 'quần jogger',
        OVERALLS: 'quần yếm',
        MINI_SKIRT: 'váy ngắn',
        SKIRT: 'chân váy',
        MINI_DRESS: 'đầm ngắn',
        DRESS: 'đầm',
        BIKINI: 'đồ tắm 2 mảnh',
        RASH_GUARD: 'đồ bơi bảo vệ',
        ONE_PIECE_SWIMSUIT: 'đồ tắm 1 mảnh',
        BEACH_TOPS: 'áo mặc đi biển',
        BEACH_PANTS: 'quần mặc đi biển',
        BRA: 'áo ngực/ áo lót',
        PANTIES_UNDERWEAR: 'quần lót',
        PAJAMAS_HOMEWEAR: 'đồ mặc nhà',
        SLIP: 'đầm ngủ',
        GOWN: 'áo choàng tắm',
        CORRECTION_UNDERWEAR: 'đồ lót định hình cơ thể',
        SHOES_LOERFERS: 'giày lười',
        HEELS: 'giày cao gót',
        SPORTS_SHOES_SNEAKERS: 'giày thể thao',
        BOOTS: 'bốt (giày cao cổ)',
        SANDALS_SLIPPERS: 'dép xăng đan/ dép xỏ ngón',
        CROSS_BAG: 'túi đeo chéo',
        SHOULDER_BAG: 'túi đeo vai',
        TOTE_BAG: 'túi vải (kích thước lớn)',
        BREIF_CASE: 'cặp (túi xách) đựng tài liệu',
        WAIST_BAG: 'túi đeo hông',
        CANVAS_BAG: 'túi vải bố',
        CLUTCH_BAG: 'ví cầm tay',
        BACKPACK: 'ba lô',
        POUCH: 'túi nhỏ',
        WALLET: 'ví',
        LUGGAGE: 'vali',
        BALLCAP: 'nón lưỡi trai',
        BUCKET_HAT: 'nón vành',
        FEDORA_HAT: 'mũ phớt',
        BEANIE_HAT_WATCH_CAP: 'mũ len Beanie',
        PHONE_CASE: 'ốp lưng điện thoại',
        SOCKS: 'vớ / tất',
        WATCH: 'đồng hồ đeo tay',
        BELT: 'dây thắt lưng',
        SCARF: 'khăn choàng cổ',
        TIGHTS_STOCKINGS: 'quần tất / vớ da',
        GLOVES: 'găng tay',
        GLASSES: 'kính cận',
        SUNGLASSES: 'kính mát',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    ITEM_COLOR: {
        BLACK: 'màu đen',
        WHITE: 'màu trắng',
        GREY: 'màu xám',
        RED: 'màu đỏ',
        PINK: 'màu hồng',
        ORANGE: 'màu cam',
        BEIGE: 'màu be',
        BROWN: 'màu nâu',
        YELLOW: 'màu vàng',
        GREEN: 'màu xanh lá',
        KHAKI: 'màu xanh rêu',
        MINT: 'màu xanh bạc hà',
        BLUE: 'màu xanh ',
        NAVY: 'màu xanh đen',
        SKYBLUE: 'màu xanh da trời',
        PURPLE: 'màu tím',
        LAVENDER: 'màu tím nhạt',
        WINE: 'màu đỏ rượu',
        NEON: 'màu xanh neon',
        GOLD: 'màu vàng đồng',
        SILVER: 'màu bạc',
        CYAN: 'xanh ngọc',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    ITEM_PATTERN: {
        CHECK: 'họa tiết kẻ caro',
        STRIPE: 'họa tiết kẻ sọc',
        ZIGZAG: 'họa tiết kẻ zigzag',
        LEOPARD: 'họa tiết da báo',
        ZEBRA: 'họa tiết ngựa vằn',
        DOT: 'họa tiết chấm bi',
        CAMOUFLAGE: 'họa tiết ngụy trang, quân đội',
        PAISLEY: 'họa tiết giọt lệ xoắn',
        ARGYLE: 'họa tiết hình kim cương',
        FLORAL: 'họa tiết in hoa',
        LETTERING: 'họa tiết chữ cái',
        SKULL: 'họa tiết đầu lâu',
        GRADATION: 'họa tiết chuyển màu',
        SOLID: 'họa tiết trơn (1 màu)',
        GRAPHIC: 'họa tiết đồ họa',
        HOUNDS_TOOTH: 'họa tiết răng sói',
        COLOR_BLOCK: 'hình khối màu sắc ',
        MESH: 'vải lưới',
        UNKNOWN: 'KHÔNG XÁC ĐỊNH'
    },
    ALERT: {
        SELECT_ONE_STYLE:
            'Vui lòng chỉ chọn một phong cách!\nPlease choose only one style !\n하나의 스타일만 선택해주세요!'
    }
};
